import { z } from "zod/v4";

export const PostSubscriptionProductsRequestBodySchema = z.object({
  shopId: z.string(),
  performingUserEmail: z.string().optional(),
  subscriptionId: z.string().optional(),
});
export type PostSubscriptionProductsRequestBodyType = z.infer<
  typeof PostSubscriptionProductsRequestBodySchema
>;

export const PostSubscriptionProductsRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});
export type PostSubscriptionProductsRequestPathParamType = z.infer<
  typeof PostSubscriptionProductsRequestPathParamSchema
>;
